<template>
  <ul>
    <li v-for="info in limitCount" :key="info">
      <a v-if="info.link" :href="info.link" target="_new">
        <p>
          <span class="date">{{ info.date }}</span>
          <span class="text">{{ info.text }}</span>
        </p>
      </a>
      <p v-if="!info.link">
        <span class="date">{{ info.date }}</span>
        <span class="text">{{ info.text }}</span>
      </p>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      infolist: [
        {
          date: "2024.4.18",
          text: "コンフォートニュータウン食場第5期の5区画につきまして、カスタマイズ可能な新築プランの販売を開始いたしました。",
        },
        {
          date: "2024.3.28",
          text: "コンフォートニュータウン食場の進入路の拡張工事が完了し、よりアクセスがしやすくなりました。",
        },
        {
          date: "2024.3.1",
          text: "北原町の2棟は好評につき完売いたしました。ありがとうございました。",
        },
        {
          date: "2023.8.31",
          text: "食場分譲地I~IV完売御礼！ 新区画食場分譲地Vの土地情報を掲載いたしました。",
        },
        {
          date: "2023.6.21",
          text: "食場V-Aモデル住宅の情報を掲載いたしました。",
        },
        {
          date: "2023.4.20",
          text: "【GWも住宅見学会を開催いたします】5/3～5/7のGW期間中、住宅見学会を開催いたします。ご希望の方はぜひお問い合わせください。",
        },
        {
          date: "2023.1.1",
          text: "天草営業所は、熊本県天草市古川町10-20に移転いたしました。プラン作成、設計、土地のご紹介、すべて無料にてお手伝いいたします。ご相談をお待ちしております。ぜひお気軽にお越しください！",
        },
        // {
        //   date: "2022.12.27",
        //   text: "2023年1月7日、8日、9日に見学会を開催します。ご来場の方限定で、北原町2物件にカーポートを付け特別価格にてご案内いたします。",
        // },
        {
          date: "2020.10.27",
          text: "instagramはじめました。インテリアや外観、設備など、こだわりが詰まった住まいの情報を発信しています。",
          link: "https://www.instagram.com/nagai.home/",
        },
      ],
    };
  },
  computed: {
    limitCount() {
      return this.infolist.slice(0, 3);
    },
  },
};
</script>

<style lang="scss" scoped>
#information {
  ul {
    li {
      padding: 0.5em 0;
      transition: 0.2s;
      border-bottom: 1px solid transparent;
      box-sizing: border-box;
      position: relative;
      max-width: 90vw;
      overflow: hidden;
      &::after {
        content: "";
        width: 1em;
        height: 1px;
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        background-color: $color_sub;
        transition: 0.25s;
      }
      &:hover {
        transform: translateX(0.25em);
        color: $color_blue;
        &::after {
          width: 120%;
          background-color: $color_blue;
        }
      }
      p {
        font-size: 0.8rem;
        line-height: 1.5;
        display: flex;
        gap: 1em;
        .date {
          width: 6em;
          flex-shrink: 0;
          flex-grow: 0;
        }
      }
    }
  }
}
</style>
